import {
    useProviderConfig,
    resolveFieldOrder,
    getPersonalInfoBaseFields,
} from '@servicetitan/financing-workflow-shared';
import { PERSONAL_INFO_FIELD_REGISTRY } from '../personal-information/fieldRegistry';

export function usePersonalInfoReviewFields() {
    const config = useProviderConfig();

    const fieldOrder = resolveFieldOrder(
        getPersonalInfoBaseFields(config.useAnnualIncome),
        config.personalInfoFieldOverrides,
    );

    return {
        fieldOrder,
        fieldRegistry: PERSONAL_INFO_FIELD_REGISTRY,
    };
}
